import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="21"
        viewBox="0 0 22 21"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF">
            <path d="M11.25 15.5V.5" />
            <path
                strokeLinecap="square"
                d="M17.25 6.5l-6-6-6 6M21.25 20.5h-20"
            />
        </g>
    </svg>
);

/**
 * Toolbar button for moving selected lights upward.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered move up button.
 */
const MoveUpButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default MoveUpButton;
